<template>
  <div class="contact">
    <site-banner title="Contact Us"  :center="true" />
    <div class="relative bg-white">
      <div class="absolute inset-0">
        <div class="absolute inset-y-0 left-0 w-1/2 bg-gray-50"></div>
      </div>
      <div class="relative mx-auto max-w-7xl lg:grid lg:grid-cols-5">
        <div class="px-4 py-16 bg-gray-50 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
          <div class="max-w-lg mx-auto">
            <h5 class="text-xl font-bold text-gray-900">Contact Details</h5>
            <dl class="mt-3 space-y-1 text-base text-gray-500">
              <div>
                <dt class="sr-only">Email</dt>
                <dd class="flex items-center">
                  <fa :icon="['far', 'envelope']" class="text-xl text-gray-400" />
                  <a href="mailto:support@fleetbeacon.app" target="_blank" class="ml-3">
                    support@fleetbeacon.app
                  </a>
                </dd>
              </div>
            </dl>
            <h5 class="mt-4 text-xl font-bold text-gray-900">Company Information</h5>
            <p class="text-gray-500">
              Fleetbeacon (Pty) Ltd. <br>
              A Remote Company <br>
              Registered in South Africa <br>
              Business Reg. No. 2017/652816/07
            </p>
            <h5 class="mt-4 text-xl font-bold text-gray-900">Operating Hours</h5>
            <p class="text-gray-500">
              Monday - Friday <br>
              09h00 - 18h00 (GMT+2)
            </p>
          </div>
        </div>
        <div class="px-4 py-16 bg-white sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
          <div class="max-w-lg mx-auto lg:max-w-none">
            <div class="p-12 text-center" v-if="successful">
              <div class="max-w-xs mx-auto text-lg">
                <checkmark size="2rem" />
                <p class="mt-4 font-bold">Thanks for reaching out!</p> 
                <p class="mt-2 text-gray-500">Your message has been sent. <br> We will respond ASAP.</p>
              </div>
            </div>
            <form @submit.prevent="submit" class="grid grid-cols-1 gap-y-6" v-else>
              <div>
                <label for="full_name" class="sr-only">Your Name</label>
                <input id="full_name" type="text" class="shadow-sm form-input" placeholder="Your Name" v-model="form.name" required>
              </div>
              <div>
                <label for="email" class="sr-only">Your Email Address</label>
                <input id="email" type="email" class="shadow-sm form-input" placeholder="Your Email Address" v-model="form.email" required>
              </div>
              <div>
                <label for="message" class="sr-only">Message</label>
                <textarea id="message" rows="4" class="shadow-sm form-input" placeholder="Message" v-model="form.message" required></textarea>
              </div>
              <div >
                <button type="submit" class="btn btn-primary btn-lg" v-submitting="submitting">Send Message &rarr;</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Checkmark from '@/components/Checkmark'
  import SiteBanner from '@/components/SiteBanner'

  export default {
    name: 'Contact',

    metaInfo: {
      title: 'Contact Us'
    },

    components: {
      Checkmark,
      SiteBanner
    },

    data () {
      return {
        successful: false,
        submitting: false,
        countryOptions: [
          { value: null, text: 'Select your country...'},
          { value: 'Australia', text: 'Australia' },
          { value: 'Austria', text: 'Austria' },
          { value: 'Belgium', text: 'Belgium' },
          { value: 'Canada', text: 'Canada' },
          { value: 'Chile', text: 'Chile' },
          { value: 'Czech Republic', text: 'Czech Republic' },
          { value: 'Denmark', text: 'Denmark' },
          { value: 'France', text: 'France' },
          { value: 'Germany', text: 'Germany' },
          { value: 'Italy', text: 'Italy' },
          { value: 'Ireland, Republic of', text: 'Ireland, Republic of' },
          { value: 'Luxembourg', text: 'Luxembourg' },
          { value: 'Mexico', text: 'Mexico' },
          { value: 'New Zealand', text: 'New Zealand' },
          { value: 'Netherlands, The', text: 'Netherlands, The' },
          { value: 'Poland', text: 'Poland' },
          { value: 'Portugal', text: 'Portugal' },
          { value: 'Russia', text: 'Russia' },
          { value: 'Spain', text: 'Spain' },
          { value: 'South Africa', text: 'South Africa' },
          { value: 'Sweden', text: 'Sweden' },
          { value: 'Switzerland', text: 'Switzerland' },
          { value: 'United Kingdom', text: 'United Kingdom' },
          { value: 'USA', text: 'USA' },
          { value: 'Other', text: 'Other' }
        ],
        fleetOptions: [
          { value: null, text: 'Please select an option' },
          { value: 'Less than 25 vehicles', text: 'Less than 25 vehicles' },
          { value: '25-100 vehicles', text: '25-100 vehicles' },
          { value: 'More than 100 vehicles', text: 'More than 100 vehicles' }
        ],
        industryOptions: [
          { value: null, text: 'Select your industry...' },
          { value: 'Construction & Materials', text: 'Construction & Materials' },
          { value: 'Services', text: 'Services' },
          { value: 'Transportation & Logistics', text: 'Transportation & Logistics' },
          { value: 'Education', text: 'Education' },
          { value: 'Energy & Utilities', text: 'Energy & Utilities' },
          { value: 'Food & Beverage', text: 'Food & Beverage' },
          { value: 'Government', text: 'Government' },
          { value: 'Health Care', text: 'Health Care' },
          { value: 'Nonprofit', text: 'Nonprofit' },
          { value: 'Retail', text: 'Retail' },
          { value: 'Trucking', text: 'Trucking' },
          { value: 'Other', text: 'Other' }
        ],
        form: {
          name: '',
          organisation: '',
          country: null,
          email: '',
          fleet: null,
          industry: null,
          subject: '',
          message: ''
        }
      }
    },

    methods: {
      async submit () {
        try {
          this.submitting = true
          await this.$api.post('site/form', this.form)
          this.submitting = false
          this.successful = true
        } catch (error) {
          console.error(error)
          this.submitting = false
        }
      }
    }
  }
</script>